import { MessagePrimitive, useAuiState } from "@assistant-ui/react";
import { AssistantBodyBubble } from "@circle-react-shared/AiConversation/message/AssistantBodyBubble";
import { CopyMessageAction } from "@circle-react-shared/AiConversation/message/CopyMessageAction";
import { MessageActions } from "@circle-react-shared/AiConversation/message/MessageActions";
import {
  useIsMessageRunning,
  useMessageHasContent,
} from "@circle-react-shared/AiConversation/message/messageRunState";
import { Sources } from "@circle-react-shared/AiConversation/message/Sources";
import { ThinkingIndicator } from "@circle-react-shared/AiConversation/status/ThinkingIndicator";

import { t } from "@/i18n-js/instance";

import { AiPauseDivider } from "./AiPauseDivider";
import type { AvatarMessageMetadata } from "./avatarThreadMessages";
import { PreviewSteps } from "./PreviewSteps";
import { avatarPartComponents } from "./TiptapBodyPart";

export const AvatarAssistantMessage = () => {
  const isRunning = useIsMessageRunning();
  const hasContent = useMessageHasContent();
  const metadata = useAuiState(
    s => s.message.metadata.custom as AvatarMessageMetadata | undefined,
  );
  const sources = metadata?.sources;
  const steps = metadata?.steps;
  const isAiPaused = metadata?.aiPauseChange;
  const isThinking = isRunning && !hasContent;

  if (isThinking) {
    return (
      <MessagePrimitive.Root data-testid="avatar-assistant-message">
        <ThinkingIndicator
          label={t("community_inbox.prompt_thinking_message")}
        />
      </MessagePrimitive.Root>
    );
  }

  return (
    <MessagePrimitive.Root data-testid="avatar-assistant-message">
      {isAiPaused !== undefined && <AiPauseDivider isPaused={isAiPaused} />}
      {/* The actions row is revealed by a sibling-hover selector, so the peer
          has to sit at this level rather than inside the shared bubble. */}
      <div className="peer/bubble">
        <AssistantBodyBubble>
          <MessagePrimitive.Parts components={avatarPartComponents} />
        </AssistantBodyBubble>
        {!isRunning && !!sources?.length && (
          <div className="mt-3">
            <Sources sources={sources} />
          </div>
        )}
        {!isRunning && !!steps?.length && (
          <div className="mt-3">
            <PreviewSteps steps={steps} />
          </div>
        )}
      </div>
      {!isRunning && (
        <MessageActions actionsAlignment="start" showTime={false}>
          <CopyMessageAction />
        </MessageActions>
      )}
    </MessagePrimitive.Root>
  );
};
